export default {
	state: {
		userInfo: { // 用户信息窗口
			show: false,
			user: {},
			pos: {
				x: 0,
				y: 0
			}
		},
		fullImage: { // 全屏大图
			show: false,
			url: "",
			imageList: [],
			currentIndex: 0,
			allowSwitch: true
		},
		viewCode: 1
	},
	mutations: {
		showUserInfoBox(state, user) {
			state.userInfo.show = true;
			state.userInfo.user = user;

		},
		setUserInfoBoxPos(state, pos) {
			let w = document.documentElement.clientWidth;
			let h = document.documentElement.clientHeight;
			state.userInfo.pos.x = Math.min(pos.x, w - 350);
			state.userInfo.pos.y = Math.min(pos.y, h - 200);
		},
		closeUserInfoBox(state) {
			state.userInfo.show = false;
		},
		showFullImageBox(state, payload) {
			if (typeof payload === 'string') {
				// 兼容旧的调用方式 - 禁用切换
				state.fullImage.show = true;
				state.fullImage.url = payload;
				state.fullImage.imageList = [payload];
				state.fullImage.currentIndex = 0;
				state.fullImage.allowSwitch = false;
			} else {
				// 新的调用方式，支持图片列表
				state.fullImage.show = true;
				state.fullImage.url = payload.url || payload.imageList[payload.index];
				state.fullImage.imageList = payload.imageList || [payload.url];
				state.fullImage.currentIndex = payload.index || 0;
				state.fullImage.allowSwitch = payload.allowSwitch !== false;
			}
		},
		changeFullImageIndex(state, index) {
			if (index >= 0 && index < state.fullImage.imageList.length) {
				state.fullImage.currentIndex = index;
				state.fullImage.url = state.fullImage.imageList[index];
			}
		},
		closeFullImageBox(state) {
			state.fullImage.show = false;
			state.fullImage.url = "";
			state.fullImage.imageList = [];
			state.fullImage.currentIndex = 0;
		},
		changeViewCode(state, code) {
			state.viewCode = code;
		},
		clear(state) {
			// 重置UI状态到初始值
			state.userInfo = {
				show: false,
				user: {},
				pos: {
					x: 0,
					y: 0
				}
			};
			state.fullImage = {
				show: false,
				url: "",
				imageList: [],
				currentIndex: 0
			};
			state.viewCode = 1;
		}
	}
}